<template>
  <div class="container is-fluid">
    <div class="tile is-ancestor">

      <div class="tile is-vertical">
        <article class="tile is-child">
          <p class="title is-1" align="center">Customize Your Avatar!!</p>
        </article>
        <article class="tile is-child">
          <p class="title is-3" align="center">Available points: {{ user.points }}</p>
        </article>

        <div class="tile is-parent">
          <article class="tile is-child box">
            <p class="subtitle is-5" align="center">Body Parts</p>
            <img src="../assets/marketplace/body-parts.png" alt="Body Parts">
          </article>
          <article class="tile is-child box">
            <p class="subtitle is-5" align="center">Hair Styles</p>
            <img src="../assets/marketplace/hair.png" alt="Hair Styles">
          </article>

          <article class="tile is-child box">
            <p class="subtitle is-5" align="center">Clothes</p>
            <img src="../assets/marketplace/clothes.png" alt="Clothes">
          </article>
          <article class="tile is-child box">
            <p class="subtitle is-5" align="center">Accessories</p>
            <img src="../assets/marketplace/accessories.png" alt="Accessories">
          </article>

          <article class="tile is-child box">
            <p class="subtitle is-5" align="center">Shoes</p>
            <img src="../assets/marketplace/shoes.png" alt="Shoes">
          </article>
          <article class="tile is-child box">
            <p class="subtitle is-5" align="center">Eyewear</p>
            <img src="../assets/marketplace/eyeware.png" alt="Eyeware">
          </article>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

  export default {
    data() {
      return {
      }
    },
    computed: {
      ...mapGetters([
        'user'
      ])
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Market.vue